import React from "react";
import "./MemberRegistrationStatus.css";
import { PiClockBold } from "react-icons/pi";
import { BsCheckCircle, BsDot } from "react-icons/bs";
import { AiOutlineCloseCircle } from "react-icons/ai";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";

export enum MemberRegistrationModule {
  KYCDetails = 2,
  PaymentDetails = 3,
}

const MemberRegistrationStatus = ({
  statusId,
  memberRegistrationModule,
  rejectReasons = [],
}) => {
  switch (memberRegistrationModule) {
    case MemberRegistrationModule.KYCDetails:
      switch (statusId) {
        case ApplicationStatus.MemberRegistrationModule_PendingWithHRHOD:
          return (
            <div className="reg-status-container reg-status-container-pending">
              <div className="d-flex justify-content-center align-items-center">
                <PiClockBold className="reg-status-icon reg-status-icon-pending mx-2" />
                <span className="reg-status-text reg-status-text-pending">
                  The status of your application is under approval. We will
                  notify you as soon as it gets approved.
                </span>
              </div>
            </div>
          );
        case ApplicationStatus.MemberRegistrationModule_PendingWithMemberForPaymentDetails:
          return (
            <div className="reg-status-container reg-status-container-approved">
              <div className="d-flex justify-content-center align-items-center">
                <BsCheckCircle className="reg-status-icon reg-status-icon-approved mx-2" />
                <span className="reg-status-text reg-status-text-approved">
                  Your Member details & KYC details has been approved. Kindly click on "Next" button to proceed with
                  payment.
                </span>
              </div>
            </div>
          );
        case ApplicationStatus.MemberRegistrationModule_RejectedHRHOD:
          return (
            <div className="reg-status-container reg-status-container-rejected">
              <div className="d-flex justify-content-center align-items-center">
                <AiOutlineCloseCircle className="reg-status-icon reg-status-icon-rejected mx-2" />
                <span className="reg-status-text reg-status-text-rejected">
                  Unfortunately, your application has been rejected, due to the following reasons:
                </span>
              </div>
              <span className="reg-status-text reg-status-text-rejected">
                <ul>
                  {rejectReasons?.map((rr) => {
                    return (
                      <li>
                        <BsDot className="rejected-bullet" />
                        {rr}
                      </li>
                    );
                  })}
                </ul>
              </span>
            </div>
          );
        default:
          return null;
      }
    case MemberRegistrationModule.PaymentDetails:
      switch (statusId) {
        case ApplicationStatus.MemberRegistrationModule_PendingWithInternalTeam:
        case ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee:
          return (
            <div className="reg-status-container reg-status-container-pending">
              <div className="d-flex justify-content-center align-items-center">
                <PiClockBold className="reg-status-icon reg-status-icon-pending mx-2" />
                <span className="reg-status-text reg-status-text-pending">
                  The status of your application is under approval. We will
                  notify you as soon as it gets approved.
                </span>
              </div>
            </div>
          );
        case ApplicationStatus.MemberRegistrationModule_MemberRequestApproved:
          return (
            <div className="reg-status-container reg-status-container-approved">
              <div className="d-flex justify-content-center align-items-center">
                <BsCheckCircle className="reg-status-icon reg-status-icon-approved mx-2" />
                <span className="reg-status-text reg-status-text-approved">
                  Payment verification completed successfully.
                </span>
              </div>
            </div>
          );
        case ApplicationStatus.MemberRegistrationModule_MemberRequestRejected:
        case ApplicationStatus.MemberRegistrationModule_RejectedByInternalTeam:
          return (
            <div className="reg-status-container reg-status-container-rejected">
              <div className="d-flex justify-content-center align-items-center">
                <AiOutlineCloseCircle className="reg-status-icon reg-status-icon-rejected mx-2" />
                <span className="reg-status-text reg-status-text-rejected">
                  Unfortunately, your application has been rejected, due to the following reasons:
                </span>
              </div>
              <span className="reg-status-text reg-status-text-rejected">
                <ul>
                  {rejectReasons?.map((rr) => {
                    return (
                      <li>
                        <BsDot className="rejected-bullet" />
                        {rr}
                      </li>
                    );
                  })}
                </ul>
              </span>
            </div>
          );
        default:
          return null;
      }
    default:
      return null;
  }
};

export default MemberRegistrationStatus;
